export const isJsonString = (str?: string) => {
  if (!str || typeof str !== "string" || str === "") return false
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}
